export namespace ModuleNameConstant {
    export const Contacts: string = "Contacts";
    export const Affiliate: string = "Affiliate";
    export const Billing : string = "Billing";
    export const Strategy : string = "Strategy";
    export const Reporting : string = "Reporting";
    export const Company : string = "Company";
}




// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/security/module-name.constant.ts